import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { tap } from "rxjs/operators";
import { LoaderService } from "../../common/services/loader.service";
import { ContactService } from "../services/contacts.service";

@Injectable()
export class ChiefsOrderGetContactAuthority {
     
    constructor(public loaderService: LoaderService,
        public contacts: ContactService) { }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        this.loaderService.toggleLoader(true);
        const contactAuthority = this.contacts.getInternalContactsByAuthority('Chief').pipe(tap((data) => { this.loaderService.toggleLoader(false); }));
        return contactAuthority;
    }

}